import { Link } from "react-router-dom";
import { Button } from "../components/ui/button.js";
import { EmptyState } from "../components/ui/states.js";
import { useI18n } from "../i18n/index.js";

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <EmptyState
      title={t("common.notFound.title")}
      description={t("common.notFound.description")}
      action={
        <Button asChild variant="secondary">
          <Link to="/">{t("common.notFound.back")}</Link>
        </Button>
      }
    />
  );
}
